import React, { ReactNode, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useTheme } from '../contexts/ThemeContext';
import { criarTemaMui } from './muiTheme';

/**
 * Ponte entre o ThemeContext (claro/escuro) e os componentes MUI (Avisos,
 * Relatórios) — sem isso, esses componentes ficariam sempre no tema padrão
 * do MUI (claro), ignorando o modo escuro do restante do app.
 */
const MuiThemeBridge: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { tema } = useTheme();
  const muiTheme = useMemo(() => criarTemaMui(tema), [tema]);

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};

export default MuiThemeBridge;
